import { getInstance } from "./index";
import { getSideBarItems } from "../../services/authorize";
import {routes} from '../../router/routes'
// import axios from "axios";


let routes_map = {};
let sidebar=[];

function create_route_map(sidebar){

   let map = {}

   for (let r of routes){
      if (r.name != undefined){
         map[r.name] = r;

      }
   }

   // for (let r of sidebar){
   //    if (r.name != undefined){
   //
   //       map[r.name] = true;
   //
   //    }
   // }

   return map;
}

function can_access(route, user){

   let r2 = routes_map[route.name];
   if (r2 != undefined && r2.auth != undefined){
      return (r2.auth.acct_types.includes(user.acct_type) && r2.auth.role_types.includes(user.user_role) )
   }
   else{
      return true;
   }
}



export const authGuard = (to, from, next) => {
   const authService = getInstance();



   const fn = async () => {

      console.log('I ran', sidebar, to, from)
      // If the user is authenticated, continue with the route
      if (authService.isAuthenticated) {
         // this.$getAgencySettings();

         // return next();

         if (to.name === 'ErrorUnauthorized'){
            return next();
         }

         if (can_access(to, authService.profile) ){
            return next();
         }
         else{
            return next({name: 'ErrorUnauthorized', query: {path: to.path}})
         }
      }
      else{
         // Otherwise, log in
         await authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
      }


   };





   // If loading has already finished, check our auth state using `fn()`
   if (!authService.loading) {
      return fn();
   }

   // Watch for the loading property to change before we check isAuthenticated
   authService.$watch("loading", loading => {
      if (loading === false) {
         if (authService.isAuthenticated){
            sidebar = getSideBarItems(authService.profile);
            routes_map = create_route_map(sidebar)
         }
         return fn();
      }
   });



};







